import { EPageActionTypes, EPageType } from '../../types/page/pageType';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export type TSetPageType = ITypedReduxAction<EPageActionTypes.SetPageType, EPageType>;

/**
 * Redux action, который записывает в store тип показываемой страницы
 * @param pageType EPageType
 */

export const setPageType: (pageType: EPageType) => TSetPageType = actionGenerator<
  EPageActionTypes.SetPageType,
  EPageType
>(EPageActionTypes.SetPageType);
